import { isDev, isTestServer } from '@twistopayments/design-system/environment'

import { Composite } from './analytics-service'
import { DevAnalyticsService } from './providers/dev'
import { FirebaseAnalyticsService } from './providers/firebase'
import GtmAnalyticsService from './providers/gtm'

export const analytics = new Composite([
  new GtmAnalyticsService(),
  new FirebaseAnalyticsService(),
])

if (isDev || isTestServer) {
  analytics.addProvider(new DevAnalyticsService())
}
